export default class HealthBar extends PIXI.Container {
    constructor() {
        super();

        this._health = 1;
        this._healthSmooth = this._health;
        this._healthEase = 12;

        this._colors = [0xFF3100, 0xFC7200, 0xFFAB17, 0xFFF403, 0x4CE700];

        this._frame = new PIXI.Sprite(P3.assets.texture("ui_char_health_bg"));
        this._frame.position.set(-this._frame.texture.width * 0.5, 0);
        this._frame.anchor.set(0, 0.5);
        this.addChild(this._frame);

        this._fill = new PIXI.Sprite(P3.assets.texture("ui_char_health_fill"));
        this._fill.position.set(-this._fill.texture.width * 0.5, 0);
        this._fill.anchor.set(0, 0.5);
        this.addChild(this._fill);

        this._fill.mask = new PIXI.Graphics();
        this._fill.mask.beginFill(0xFF0000, 1);
        this._fill.mask.drawRect(0, -this._fill.texture.height * 0.5, this._fill.texture.width, this._fill.texture.height);
        this._fill.mask.endFill();
        this._fill.addChild(this._fill.mask);

        this._gloss = new PIXI.Sprite(P3.assets.texture("ui_char_health_fg"));
        this._gloss.position.set(-this._frame.texture.width * 0.5, 0);
        this._gloss.anchor.set(0, 0.5);
        this.addChild(this._gloss);
    }

    update(dt) {
        this._healthSmooth += (this._health - this._healthSmooth) * this._healthEase * dt;
        this._fill.mask.scale.x += (this._health - this._fill.mask.scale.x) * this._healthEase * dt;

        const f = Math.round(this._healthSmooth * (this._colors.length - 1));
        this._fill.tint = this._colors[f];
    }

    get health() {
        return this._health;
    }

    set health(value) {
        this._health = Math.max(0, Math.min(1, value));
    }
}